import { ABORT_ONBOARDING, SET_ONBOARDING_STEP } from "../reducers/onboarding";

export const set_onboarding_step = (step) => {
  return (dispatch) => {
    dispatch({ type: SET_ONBOARDING_STEP, step })
  }
}

export const abort_onboarding = (data) => {
  return (dispatch) => {
    dispatch({ type: ABORT_ONBOARDING, data })
  }
}